// i18n area 'tasks' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.es-ES.meta.json.
import type { enUS } from './tasks'

export const esES: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Operaciones compuestas — reanudables desde el paso fallido, o anulables',
    colType: 'Tipo',
    colTarget: 'Objeto',
    colPhase: 'Fase',
    colSteps: 'Pasos',
    empty: 'Ningún macrotask',
    detail: 'Detalles',
    failedAt: 'fallido en',
    resume: 'Reintentar desde el paso fallido',
    abort: 'Anular todo',
    cancel: 'Cancelar',
    actionError: 'La acción fue rechazada'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Buscar por tipo o target',
    type: 'Tipo',
    target: 'Target',
    phaseLabel: 'Fase',
    progress: 'Progreso',
    started: 'Iniciado',
    finished: 'Terminado',
    node: 'Nodo',
    empty: 'Ningún task',
    loadError: 'No se pudieron cargar los tasks — ¿está accesible el backend TVirt?',
    limboHint: "Nodo '{node}' inalcanzable desde las {time} — el task retiene el write lease sobre su target hasta que el nodo vuelva o sea atestado apagado",
    nodeAttested: 'Nodo atestado apagado',
    phase: {
      queued: 'En cola',
      running: 'En ejecución',
      succeeded: 'Completado',
      failed: 'Fallido',
      cancelled: 'Anulado',
      'failed-at-step': 'Fallido en un paso',
      aborted: 'Interrumpido'
    },
    dropdown: {
      tooltip: 'Tasks en curso',
      title: 'Tasks en curso',
      empty: 'Ningún task en curso',
      viewAll: 'Ver todos los tasks'
    },
    detail: {
      open: 'Detalles',
      scope: 'Ámbito',
      message: 'Mensaje',
      params: 'Parámetros',
      result: 'Resultado',
      errorTitle: 'Error',
      steps: 'Pasos',
      failedAt: 'fallido en',
      superseded: 'superado',
      step: 'Paso',
      parent: 'Task padre',
      failedStep: 'Paso fallido',
      log: 'Log',
      logEmpty: 'Aún ninguna línea de log',
      close: 'Cerrar'
    },
    actions: {
      cancel: 'Cancelar',
      resume: 'Reintentar desde el paso fallido',
      abort: 'Anular todo (undo de los pasos completados)',
      refused: 'La acción fue rechazada'
    }
  },
  events: {
    loadError: 'No se pudo cargar el diario — ¿el backend TVirt es accesible?',
    title: 'Eventos',
    subtitle: 'La memoria histórica del clúster: hechos consumados, del más reciente',
    filterSeverity: 'Gravedad',
    filterCategory: 'Categoría',
    filterAll: 'Todas',
    searchLabel: 'Buscar',
    searchPlaceholder: 'Buscar en todo el diario',
    subjectFilter: 'Eventos de {subject} — mostrar todos',
    colAt: 'Cuándo',
    colSeverity: 'Gravedad',
    colType: 'Tipo',
    colSubject: 'Sujeto',
    colActor: 'Quién',
    colNode: 'Nodo',
    colMessage: 'Mensaje',
    empty: 'Ningún evento',
    loadMore: 'Cargar más',
    actorSystem: 'sistema',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID del evento',
    taskCollectedHint: 'El task tiene una retención más corta: si ya fue recogido el enlace no responde',
    severity: {
      info: 'Información',
      warning: 'Aviso',
      error: 'Error',
      critical: 'Crítico'
    },
    category: {
      lifecycle: 'Ciclo de vida',
      config: 'Configuración',
      availability: 'Disponibilidad',
      security: 'Seguridad'
    },
    type: {
      haNetsvcFailedOver: 'Failover del servicio de red',
      haNetsvcNoCandidate: 'Servicio de red sin nodo candidato',
      haNetsvcReaped: 'Instancia local segada en el reingreso',
      netsvcFloatipMoved: 'IP flotante movida a otro titular',
      netsvcFloatipNoHolder: 'IP flotante sin objetivo sano',
      haAppFailedOver: 'Failover de la instancia App',
      haAppNoCandidate: 'Instancia App sin nodo candidato',
      haAppStorageLocalSkip: 'Instancia App no movida: datos persistentes locales al nodo muerto',
      haAppReaped: 'Pod local de la instancia App segado al reingresar'
    }
  },
  audit: {
    loadError: 'No se pudo cargar el registro de auditoría — ¿el backend TVirt es accesible?',
    title: 'Auditoría',
    subtitle: 'Quién hizo qué, cuándo y sobre qué objeto — actos intentados, rechazos incluidos',
    filterOutcome: 'Resultado',
    filterAll: 'Todos',
    filterSudo: 'Solo actos elevados',
    colAt: 'Cuándo',
    colActor: 'Quién',
    colAction: 'Acción',
    colTarget: 'Objeto',
    colOutcome: 'Resultado',
    colNode: 'Nodo',
    empty: 'Ningún acto registrado',
    loadMore: 'Cargar más',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Ruta',
    detailProblem: 'Motivo',
    detailTask: 'Task',
    detailClientIp: 'Desde',
    detailId: 'ID del registro',
    detailSession: 'Sesión',
    taskHint: 'El resultado de un acto aceptado vive en el diario de eventos, bajo este mismo id de task',
    outcome: {
      succeeded: 'Realizado',
      accepted: 'Aceptado',
      denied: 'Denegado',
      rejected: 'Rechazado',
      failed: 'Fallido'
    }
  },
  notifications: {
    loadError: 'No se pudieron cargar las notificaciones — ¿el backend TVirt es accesible?',
    actionError: 'La acción fue rechazada',
    title: 'Notificaciones',
    subtitle: 'Los destinos hacia los que los hechos del diario salen del clúster',
    rulesTitle: 'Reglas',
    rulesSubtitle: 'Qué hechos salen, y hacia dónde',
    deliveriesTitle: 'Entregas',
    deliveriesSubtitle: 'El resultado de cada notificación, con el porqué cuando falla',
    colName: 'Nombre',
    colKind: 'Tipo',
    colWhere: 'Dónde',
    colScope: 'Scope',
    colSeverity: 'Gravedad',
    colMatch: 'Filtro',
    colTargets: 'Destino',
    colAt: 'Cuándo',
    colState: 'Estado',
    colEvent: 'Evento',
    colAttempts: 'Intentos',
    colOutcome: 'Resultado',
    empty: 'Ninguna fila',
    matchAll: 'todos los hechos',
    test: 'Probar',
    testOk: 'Notificación de prueba entregada a {target}',
    testFailed: 'Prueba hacia {target} fallida: {reason}',
    retry: 'Reencolar',
    retried: 'Entrega reencolada',
    grouped: 'y otras {count} repeticiones',
    state: {
      failed: 'Fallida',
      pending: 'En cola',
      sending: 'Enviándose',
      sent: 'Enviada'
    },
    tabTargets: 'Destinos',
    tabRules: 'Reglas',
    tabDeliveries: 'Entregas',
    targetCreateTitle: 'Nuevo destino',
    ruleCreateTitle: 'Nueva regla',
    nameHint: 'Minúsculas, dígitos y guiones; único por ámbito',
    kindImmutableHint: 'Inmutable: cambiar el tipo significa crear otro destino',
    kindSmtp: 'Correo (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Estado',
    enabledOn: 'Activo',
    enabledOff: 'Suspendido',
    smtpHost: 'Servidor SMTP',
    smtpPort: 'Puerto',
    smtpPortHint: 'Habitual: 25 sin TLS, 587 con starttls, 465 con tls',
    smtpSecurity: 'Seguridad',
    smtpFrom: 'Remitente',
    smtpTo: 'Destinatarios',
    smtpToHint: 'Una o más direcciones separadas por comas',
    webhookUrl: 'URL',
    payload: 'Contenido',
    payloadHint: 'Con minimal el mensaje y los datos del evento no salen del clúster',
    credential: 'Credencial',
    credentialNone: 'Ninguna',
    credentialHintSmtp: 'La cuenta del relay desde el keystore; ninguna significa SMTP anónimo',
    credentialHintWebhook: 'El secreto de firma desde el keystore; sin firma, cualquiera que conozca la URL puede hacerse pasar por el clúster',
    minSeverityHint: 'Un umbral, no un conjunto: desde esta gravedad en adelante',
    categories: 'Categorías',
    categoriesHint: 'Vacío = todas',
    types: 'Tipos de evento',
    typesHint: 'Separados por comas; vacío = todos. Un tipo desconocido se rechaza',
    targetsHint: 'Al menos uno; deben vivir en el ámbito de la regla o en un antecesor',
    recursiveOn: 'También los ámbitos hijos',
    recursiveOff: 'Solo este ámbito',
    recursiveHint: 'Los recursos viven en las hojas: sin los hijos una regla en la raíz notifica casi nada',
    repeatWindow: 'Ventana de agrupación (s)',
    repeatWindowHint: 'Dentro de la ventana las repeticiones no envían correo: se cuentan en la primera. 0 lo desactiva',
    targetInUseError: 'El destino {name} todavía lo usa una regla'
  }
}
